/**
 * Configuration file for exporting environment variables and api urls
 */

const domain = window.location.host;
const origin = window.location.origin;
const APP_LOCAL_PATH = "developer.gartner.com";
const GENIE_AUTH_ENV = {
  LOCAL: "http://toolsdv.gartner.com/account/signin",
};
let gcomUrl = "";
let toolUrl = "";

const gartnerUrls = {
  dev: "https://gcom.pdodev.aws.gartner.com",
  qa: "https://gcom.pdoqa.aws.gartner.com",
  prod: "https://www.gartner.com",
};

const toolsUrls = {
  prod: "https://tools.gartner.com",
  qa: "https://toolsqa.gartner.com",
  dev: "https://toolsdv.gartner.com",
};

const hosts = {
  dev: "tools.pdotoolsdev.aws.gartner.com, toolsdv.gartner.com, developer.gartner.com",
  qa: "tools.pdotoolsqa.aws.gartner.com, toolsqa.gartner.com",
};

if (hosts.dev.indexOf(domain) !== -1) {
  gcomUrl = gartnerUrls.dev;
  toolUrl = toolsUrls.dev;
} else if (hosts.qa.indexOf(domain) !== -1) {
  gcomUrl = gartnerUrls.qa;
  toolUrl = toolsUrls.qa;
} else {
  gcomUrl = gartnerUrls.prod;
  toolUrl = toolsUrls.prod;
}
const config = {
  domain,
  origin,
  GARTNER_URL: gcomUrl,
  TOOL_URL: toolUrl,
  API_PATH: {
    LOGOUT: "/api/auth/logout",
    LOGIN: "/account/signin",
  },
  BASE_URL: "/use-case-insights",
  APP_LOCAL_PATH,
  GENIE_AUTH_URL: GENIE_AUTH_ENV.LOCAL,
  GENIE_ACCESS_CODE: "genie_uid",
  LOGOUT_EVENT_KEY: "logout-event",
};
export default config;
